<template>
    <div class="register">
        <div class="register-header">
            <div class="logo-header-box">
                <div class="header-left" @click="HandleImgPage">
                    <img src="../../assets/newLogo.png" alt="">
                    <span  v-show="widthNew">Hi~，欢迎注册</span>
                </div>
                <div class="header-right">
                    <div v-show="widthNew">
                        <span>如有疑问？</span>
                        <span class="textSky"><i class="el-icon-s-custom"></i>在线咨询</span>
                        <span class="header-sep">|</span>
                    </div>
                    <router-link to="/login">
                        <div style="color: #333;">
                            <span  v-show="widthNew">已有账号？</span>
                            <span class="textSky">去登陆 》</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="step-1">
            <div class="stepsD">
                <div class="selectSta">
                    <p :class="avitve == 0?'activeP':''" @click="avitve = 0">普通会员注册</p>
                    <p :class="avitve == 1?'activeP':''" @click="avitve = 1">企业会员注册</p>
                </div>
                <!-- <el-steps :active="avitve" finish-status="success" align-center>
                    <el-step title="填写账号信息" ></el-step>
                    <el-step title="填写企业信息" ></el-step>
                    <el-step title="注册成功" ></el-step>
                </el-steps> -->
            </div>
            <div class="register-from">
                <el-form :model="RegisterFrom" :rules="rulesRegisterFrom" ref="RegisterFrom"  v-show="avitve == 0">
                    <el-form-item>
                        <el-input placeholder="请填写邀请码" v-model="RegisterFrom.invitation">
                            <template slot="prepend">
                                <span class="spacing1">邀请码</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-cascader
                            ref="cascader"
                            placeholder="请选择所属区域"
                            v-model="RegisterFrom.options"
                            :options="optionsOptions"
                            :props="props">
                            <template slot="prepend">所属区域</template>
                        </el-cascader>
                    </el-form-item>
                    <el-form-item prop="phone">
                        <el-input placeholder="请填写手机号码" v-model="RegisterFrom.phone" >
                            <template slot="prepend">
                                <span class="spacing2">中国 +86</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <el-input class="leftNone" placeholder="请填写短信验证码" v-model="RegisterFrom.code">
                            <template slot="prepend">手机验证码</template>
                            <template slot="append">
                                <el-button type="primary" @click="handleRegisterFrom">获取验证码</el-button>
                            </template>
                        </el-input>
                        
                    </el-form-item>
                    <el-form-item>
                        <el-input class="leftNone" v-model="RegisterFrom.userName" placeholder="账号唯一识别，可用来登陆">
                            <template slot="prepend">
                                <span class="spacing1">账号名</span>
                            </template>
                            
                        </el-input>
                        
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input class="leftNone" show-password v-model="RegisterFrom.password" type="password" placeholder="请设置登陆密码">
                            <template slot="prepend">设置密码</template>
                        </el-input>
                         
                    </el-form-item>
                    <div class="checkde">
                        <el-checkbox v-model="checked"></el-checkbox>
                        <p class="userAgreement">我已阅读并同意<span @click="getRegister">《注册用户协议》</span></p>
                    </div>
                    <div style="display: flex;justify-content: space-between;">
                        <!-- <el-button type="primary" style="width: 48%;"  @click="handleNext">下一步</el-button>
                        <el-button type="primary" style="width: 48%;"  @click="avitve = 1">跳过</el-button> -->
                        <el-button type="primary" class="regisButton" @click="vsRegister">注册</el-button>
                    </div>
                    
                
                   
                </el-form>
                    
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" v-show="avitve == 1">
                    <el-form-item prop="joinType">
                        <el-select v-model="ruleForm.joinType" multiple placeholder="请选择企业类型" style="width: 100%;">
                            <el-option
                                v-for="item in options"
                                :key="item.cate_id"
                                :label="item.cate_name"
                                :value="item.cate_id">
                            </el-option>
                            <template slot="prepend">
                                <span>企业类型</span>
                            </template>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item prop="joinName">
                        <el-input v-model="ruleForm.joinName" placeholder="请填写企业名称">
                            <template slot="prepend">
                                <span>企业名称</span>
                            </template>
                        </el-input>
                    </el-form-item>
                
                    <el-form-item prop="creditCode">
                        <el-input v-model="ruleForm.creditCode" placeholder="请填写统一社会信用代码">
                            <template slot="prepend">
                                <span>信用代码</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="user_mobile">
                        <el-input v-model="ruleForm.user_mobile" placeholder="请填写登陆账号">
                            <template slot="prepend">
                                <span>登录账号</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="user_password">
                        <el-input v-model="ruleForm.user_password" placeholder="请填写登陆密码">
                            <template slot="prepend">
                                <span>登录密码</span>
                            </template>
                        </el-input>
                    </el-form-item>
                  
                    <el-form-item prop="region">
                        <el-cascader class="InputW"
                            ref="cascader"
                            v-model="ruleForm.region"
                            :options="optionsOptions"
                            :props="props"
                            placeholder="请选择区县"
                        >
                        <template slot="prepend">
                            <span>区县</span>
                        </template>
                    </el-cascader>
                    </el-form-item>
                    <el-form-item prop="contacts">
                        <el-input v-model="ruleForm.contacts" placeholder="请填写联系人">
                            <template slot="prepend">
                                <span class="spacing3">联系人</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item prop="address">
                        <el-input v-model="ruleForm.address" placeholder="请填写地址">
                            <template slot="prepend">
                                <span class="spacing3">地 &nbsp;址</span>
                            </template>
                        </el-input>
                    </el-form-item> -->
                   
                    <el-form-item prop="phone">
                        <el-input v-model="ruleForm.phone" placeholder="请填写电话号码">
                            <template slot="prepend">
                                <span>手机号码</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="smscode">
                        <el-input class="leftNone" placeholder="请填写短信验证码" v-model="ruleForm.smscode">
                            <template slot="prepend">
                                <span class="spacing3">验证码</span>
                            </template>
                            <template slot="append">
                                <el-button type="primary" @click="handleRuleFrom">获取验证码</el-button>
                            </template>
                        </el-input>
                        
                    </el-form-item>
                    <el-form-item prop="profile">
                        <el-input type="textarea" :rows="4" v-model="ruleForm.profile" placeholder="请填写企业简介(限 500 字以内)">
                            <template slot="prepend">
                                <span>企业简介</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="图片LOGO" prop="picture" :label-width="widthNew?'75px':'26%'" >
                        <div class="list-card-img">
                            <img width="200px" height="150px" v-for="item in ruleForm.picture" :key="item.FileUrl" :src="item.FileUrl" alt="">
                            <el-upload
                                ref="upload"
                                :http-request="handlePicture"
                                action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                            >
                                <i class="el-icon-plus borderI" ></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="营业执照" prop="qualificationImage">
                        <div class="list-card-img">
                            <img width="200px" height="150px" v-for="item in ruleForm.businessLicense" :key="item.FileUrl" :src="item.FileUrl" alt="">
                            <el-upload
                                ref="upload"
                                :http-request="handleBusinessLicense"
                                action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                            >
                                <i class="el-icon-plus borderI" ></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="资质图片" prop="qualificationImage">
                        <div class="list-card-img">
                            <img width="200px" height="150px" v-for="item in ruleForm.qualificationImage" :key="item.FileUrl" :src="item.FileUrl" alt="">
                            <el-upload
                                ref="upload"
                                :http-request="handleQualificationImage"
                                action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                            >
                                <i class="el-icon-plus borderI" ></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <div class="checkde">
                        <el-checkbox v-model="checkedTwo"></el-checkbox>
                        <p class="userAgreement">我已阅读并同意<span @click="getRegister">《注册用户协议》</span></p>
                    </div>
                    <el-form-item>
                        <div style="display: flex;justify-content: space-between;">
                            <!-- <el-button type="primary" style="width: 48%;"  @click="avitve = 0">上一步</el-button> -->
                            <el-button type="primary" class="regisButton" @click="handleJoin">注册</el-button>
                        </div>
                        
                    </el-form-item>
                </el-form>
<!-- 
                <div v-show="avitve == 2">
                    <el-result icon="success" title="注册成功">
                        <template slot="extra">
                            <el-button type="primary" size="medium">去登陆</el-button>
                        </template>
                    </el-result>
                </div> -->
            </div>
        </div>

        <el-dialog
            title="注册用户协议"
            :visible.sync="dialogRegister"
            customClass="messageDialog"
            >
            <div  v-if="helpHtml != ''" v-html="helpHtml" ></div>
           
        </el-dialog>  
    </div>
</template>
<script> 
export default{
    data(){
        var validatePassword = (rule, value, callback) => {
            const regex = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
            if (!regex.test(value)) {
                callback(new Error('密码必须包含大小写字母'));
            } else {
                callback();
            }
        }
        return{
            dialogRegister: false,
            helpHtml: '',
            checked: false,
            checkedTwo: false,
            value: [],
            widthNew: false,
            avitve: 0,
            props: {
                //开启懒加载
                lazy: true,
                lazyLoad: this.typeEconomyGetSelectList,
            },
            
           
            RegisterFrom: {
                phone: '',
                code: '',
                invitation: '',
                password: '',
                options: [],
                userName: ''
            },
            rulesRegisterFrom: {
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'change' }
                ],
                password: [
                    {  required: true, message: '请输入密码', trigger: 'change' },
                    { min: 8, message: '请输入最少8位数的密码', trigger: 'blur' },
                    { validator: validatePassword, trigger: 'blur' }
                ],
            },
            city:'',
            city_code: '',
            county: '',
            county_code: '',
            ruleForm: {
                joinType: '',
                joinName: '',
                creditCode: '',
                region: '',
                contacts: '',
                phone: '',
                profile: '',
                qualificationImage: [],
                businessLicense: [],
                picture: [],
                user_mobile: '',
                user_password: '',
                smscode: ''
            },
            rules: {
                phone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                ],
                smscode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 6, max: 6, message: '请正确输入验证码', trigger: 'blur' }
                ],
                joinType: [
                    {  required: true, message: '请选择企业类型', trigger: 'blur' }
                ],
                joinName: [
                    {  required: true, message: '请填写企业名称', trigger: 'change' }
                ],
                user_password: [
                    {  required: true, message: '请填写登录密码', trigger: 'change' }
                ],
                user_mobile: [
                    {  required: true, message: '请填写登录账号', trigger: 'change' }
                ],
                creditCode: [
                    {  required: true, message: '请填写统一社会信用代码', trigger: 'change' }
                ],
                region: [
                    {  required: true, message: '请选择所属区域', trigger: 'change' }
                ],
                contacts: [
                    {  required: true, message: '请填写联系人', trigger: 'change' }
                ],
                
                qualificationImage: [
                    {  required: true, message: '请上传资质图片', trigger: 'change' }
                ],
                businessLicense: [
                    {  required: true, message: '请上传营业执照', trigger: 'change' }
                ],
                picture: [
                    {  required: true, message: '请上传图片', trigger: 'change' }
                ],
                profile: [
                    {  required: true, message: '请填写公司简介', trigger: 'change' },
                    {  max: 500, message: '限 500 字以内', trigger: 'blur' }
                ]

               
               
            },
            options: [],
            props: {
                //开启懒加载
                lazy: true,
                lazyLoad: this.typeEconomyGetSelectList,
            },
            optionsOptions: [
                // { value: 1, label: "111",a:'a', children: [{ value: 3, label: "333" ,a:'b'}] },
                // { value: 2, label: "222",a:'c' },
                {id:1,label:'广州市',value: {code: 440100,name: '广州市'}},
                {id:2,label:'东莞市',value: {code: 441900,name: '东莞市'}}
            ],
        }
    },
    methods: {
        HandleImgPage(){
            this.$router.push({
                path: '/homePage'
            })
        },
        // 动态加载地区
        typeEconomyGetSelectList(node, resolve) {
            console.log("999999999999");
            console.log(node);
            const { level, value } = node;
            let params = {
                parent_name: node.label,
                pageSize: 99
            };
            console.log("cces");
           
            this.$store.dispatch('login/listarea',params)
                        .then(res => {
                            console.log("获取地址");
                            console.log(res);
                            if(res.ok){
                                var nodes = res.data.items.map((item) => {
                                    return {
                                        id: item.id,
                                        value: item.name,
                                        label: item.name,
                                        leaf: level >= 1,
                                        parent_id: item.parent_id,
                                        wid: item.wid,
                                        idx: item.idx,
                                    };
                                });
                                console.log(nodes);
                                resolve(nodes);
                            }
                             
                        }).catch(err => {
                            console.log("失败失败");
                            console.log(err);
                        })
        },
        getCode(val){
            let data = {
                    ac: 'appvercode',
                    phone: val,
                    usecate: "register",
                    expireTime: '5'
            }
            this.$store.dispatch('login/sendsms',data)
                .then(res => {
                    if(res.ok){

                    }else{
                        this.$alert(res.msg,'提示',{
                            confirmButtonText: '确定'
                        })
                    }
                })
         
        },
        handleRegisterFrom(){
            if(this.RegisterFrom.phone != ''){
                this.getCode(this.RegisterFrom.phone)
                
            }else{
                this.$alert('请正确填写手机号码', '提示',{
                    confirmButtonText: '确定',
                })
                                  
            }
        },
        handleRuleFrom(){
            if(this.ruleForm.phone != ''){
                this.getCode(this.RegisterFrom.phone)
                
            }else{
                this.$alert('请正确填写手机号码', '提示',{
                    confirmButtonText: '确定',
                })
                                  
            }
        },
        // handleNext(){
        //     this.$refs.RegisterFrom.validate((valid) => {
        //         if (valid) {
        //             this.active = 1
        //         }else{
        //             this.$alert('进行下一步请正确填写账号信息，也可以点击跳过，进行企业会员注册','提示',{
        //                 confirmButtonText: '确定',
        //             })
        //         }
        //     })
        // },
        // 会员注册
        vsRegister(){

            this.$refs.RegisterFrom.validate((valid) => {
                if (valid) {
                    if(this.RegisterFrom.options.length != 0){
                        if(this.checked){
                          
                            let nodesObj = this.$refs['cascader'].getCheckedNodes()
                            console.log("eeeeeeeeeeeeeeeeeee");
                            console.log(nodesObj);
                            console.log(nodesObj[0].parent.data.label);
                            this.city =  nodesObj[0].parent.data.label, //城市 
                            this.city_code = nodesObj[0].data.parent_id,//城市代 
                            this.county = nodesObj[0].data.label,//区县 
                            this.county_code = nodesObj[0].data.idx//区县代码

                            
                          let data = {
                              tuijianma: this.RegisterFrom.invitation, //邀请码
                              province: '广东省', //省
                              province_code: '440000', //省编号
                              city: this.city, //城市 
                              city_code: this.city_code,//城市代 
                              county: this.county,//区县 
                              county_code: this.county_code,//区县代码
                              user_mobile: this.RegisterFrom.phone, //手机号
                              smscode: 862928, // 验证码信息
                              user_password: this.RegisterFrom.password // 密码
                          }
                          this.$store.dispatch('login/register',data)
                              .then(res => {
                                 if(res.ok){
                                    // console.log("注册成功！！！！");
                                    // console.log(res);

                                    // this.$alert('注册成功', '提示',{
                                    //     confirmButtonText: '确定',
                                    // })
                                    this.$notify({
                                        title: '提示',
                                        message: '注册成功',
                                        type: 'success'
                                    });
                                    localStorage.setItem('token', res.data.token)
                                    localStorage.setItem("userId",res.data.loginUser.user_id) 
                                    localStorage.setItem("phone",res.data.loginUser.user_account) 
                                    this.$router.push({
                                        path: '/login'
                                    })
                                 }else{
                                    this.$notify({
                                        title: '提示',
                                        message: res.msg,
                                        type: 'error'
                                    })
                            }
                          })


                      }else{
                          this.$alert('您必须同意用户协议才能注册','提示',{
                              confirmButtonText: '确定'
                          })
                      }
                    }else{
                        this.$alert('请您选择所在的区域','提示',{
                              confirmButtonText: '确定'
                          })
                    }
                }
            })
            
        },
      
        getUUID(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
            })  
        },
        fileToBlob(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                    const blob = new Blob([reader.result], { type: file.type });
                    resolve(blob);
                };

                reader.onerror = reject;

                reader.readAsArrayBuffer(file);
            });
        },
        // 上传文件
        
        handleTransform(options,val){
            
            console.log("上传的文件")
            console.log(options)
            let data = {}
            this.$store.dispatch('train/policy',data)
                .then(res => {
                    if(res.ok){

                        this.fileToBlob(options.file).then(blob => {
                           
                            console.log('Blob对象:', blob);
                           
                            console.log('ossPolicyX')
                            console.log(res)
                            var info = res.data
                            var key = info.dir + this.getUUID() + options.file.name.substring(options.file.name.lastIndexOf(".")) 
                            
                            console.log('key')
                            console.log(key)
                            let formData = new FormData()

                            formData.append('key', key)
                            formData.append('OSSAccessKeyId', info.accessId)
                            formData.append('policy', info.policy)
                            formData.append('signature', info.signature)
                            formData.append('success_action_status', '200')
                            formData.append('file', options.file)
                            
                            axios({
                                url: info.host,
                                contentType: false,
                                method: 'post',
                                data: formData,
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(res => {
                                const { status } = res
                                if (status === 200) {
                                    var filename = options.file.name
                                    var pictureUrl = info.host + '/' + key;//获得到的url需要将其存数据库中
                                   if(val == 1){ // 图片
                                        this.ruleForm.picture.push({
                                            filename: filename,
                                            lanmu: 'booking',
                                            picurl: pictureUrl,
                                            FileName: filename,
                                            FileUrl: pictureUrl,

                                        })  
                                   }else if(val ==  2){ //营业执照
                                        this.ruleForm.businessLicense = []
                                        this.ruleForm.businessLicense.push({
                                            filename: filename,
                                            lanmu: 'booking',
                                            picurl: pictureUrl,
                                            FileName: filename,
                                            FileUrl: pictureUrl,

                                        })  
                                   }else if(val ==  3){//
                                        this.ruleForm.qualificationImage.push({
                                            filename: filename,
                                            lanmu: 'booking',
                                            picurl: pictureUrl,
                                            FileName: filename,
                                            FileUrl: pictureUrl,

                                        })  
                                   }

                                
                                } 
                            })
                     
                        });
						
						
					}
                })
           
        },
        handlePicture(file){ // 图片
            this.handleTransform(file,1)
        },
        handleBusinessLicense(file){ //营业执照
            this.handleTransform(file,2)
        },
        handleQualificationImage(file){ //资质图片
            this.handleTransform(file,3)
        },
        // 企业会员注册
        handleJoin(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(this.ruleForm.region);
                    if(this.checkedTwo){
                        let data = {
                            cates: this.ruleForm.joinType,
                            // 资质图片
                            cert_file: JSON.stringify(this.ruleForm.qualificationImage),
                            city: this.ruleForm.region[0].code, 
                            code: this.ruleForm.creditCode,//"信用代码"
                            contact: this.ruleForm.contacts,//"联系人",
                            county: this.ruleForm.region[1].code,
                            description: this.ruleForm.profile,//"简介"
                            // 图片
                            file_items: JSON.stringify(this.ruleForm.picture),
                            license_file:  this.ruleForm.businessLicense[0].FileUrl,
                            license_name:  "营业执照",
                            name:"企业名称",
                            // 手机号码
                            phone: this.ruleForm.phone,
                            province:"440000",
                            // 验证码信息
                            smscode: this.ruleForm.smscode,
                            // 登录账号
                            user_mobile: this.ruleForm.user_mobile,
                            user_password: this.ruleForm.user_password
                        }
                        console.log(data);
                        this.$store.dispatch('join/join2Usre',data)
                            .then(res => {
                                if(res.ok){
                                    this.$notify({
                                        title: '提示',
                                        message: '注册成功',
                                        type: 'success'
                                    })
                                    localStorage.setItem('token', res.data.token)
                                    localStorage.setItem("userId",res.data.loginUser.user_id) 
                                    localStorage.setItem("phone",res.data.loginUser.user_account) 
                                    this.$router.push({
                                        path: '/login'
                                    })
                                    
                                }else{
                                    this.$notify({
                                        title: '提示',
                                        message: res.msg,
                                        type: 'error'
                                    })
                                }
                            })
                    }else{
                        this.$alert('您必须同意用户协议才能注册','提示',{
                              confirmButtonText: '确定'
                          })
                    }
                   
                }
            })
        },
        //企业类型
        getListcate(data){
            this.$store.dispatch('join/listcate',data)
                .then(res => {
                    if(res.ok){
                        this.options = res.data
                    }
                })
           
        },

        getRegister(){
            
            let data = {
                id: 48
            }
            this.$store.dispatch('help/helpInfo',data)
                .then(res => {
                    if(res.ok){
                        if(res.data != null){
                            this.helpHtml = res.data.intro
                        }else{
                            this.helpHtml = ''
                        }
                        this.dialogRegister = true
                    }
                       
                      
                   
                })
        
        }
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let data = {
            pageSize: 999,
            parent_cate_value: 'company'
       }
       this.getListcate(data)
    }
}
</script>
<style scoped lang="scss">
.register{
    width: 100%;
    background: #fff;
    .register-header{
        width: 100%;
        background: #fff;
        box-shadow: 0 3px 8px 0 hsla(0,0%,42%,.1);
        box-sizing: border-box;
        padding: 18px 0;
        .logo-header-box{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .header-left{
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img{
                    width: 200px;height: 60px;
                    margin-top: 3px;
                }
                span:last-child {
                    padding: 3px 0 2px 18px;
                    font-size: 18px;
                    border-left: 1px solid #b8b8b8;
                    margin-left: 20px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #333;
                }
            }
            .header-right{
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 15px;
                color: #333;
                position: relative;
                left: 15px;
                .textSky{
                    color: #4095e5;
                    cursor: pointer;
                }
                .header-sep{
                    padding-left: 14px;
                    padding-right: 14px;
                }
            }
        }
       
    }

    .step-1{
        width: 419px;height: 20px;
        margin: 60px auto 43px;
        .stepsD{
            width: 479px;
            margin-left: -30px;
            ::v-deep .el-step__title.is-process {
                font-weight: 500 !important;
                color: #333333 !important;
                color: #67C23A !important;
            }
            ::v-deep .el-step__head.is-process{
                color: #67C23A !important;
                border-color: #67C23A !important;
                // border: 2px solid #67C23A !important;
            }
            .selectSta{
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                p{
                    width: 50%;
                    cursor: pointer;
                }
                p:hover{
                    color: #67C23A;
                }
                .activeP{
                    color: #67C23A;
                }
            }
            
        }
       
        .register-from{
            margin-top: 50px;
            padding-bottom: 20px;
            .el-cascader{
                width: 100%;
            }
            .el-input{
                height: 45px;
            }
            ::v-deep .el-input-group__prepend{
                width: 70px !important;
                background-color: #fff;
                
                // .el-input__inner{
                //     width: 45px !important;
                // }
            }
            .spacing1{
                letter-spacing: 9px;
            }
            .spacing2{
                letter-spacing: 2px;
            }
            .spacing3{
                letter-spacing: 6px;
            }
            .checkde{
                margin-top: 50px;
                margin-bottom: 5px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                span{
                    color: #10aeff;
                    margin-left: 10px;
                }
            }
            .regisButton{
                
                width: 100%;height: 46px;
                background: #4095e5;
                font-size: 15px;
            }
            .userAgreement{
                font-size: 14px;
                margin-left: 8px;
                color: #333;
                span{
                    cursor: pointer;
                }
            }
            .borderI{
                text-align: center;
                cursor: pointer;
                width: 200px;
                outline: 0;
                height: 150px;
                line-height: 150px;
                border-radius: 5px;
                border: 1px dashed #999999;
                font-size: 20px;
                color: #999999;
                margin-left: 5px;
            }
            .list-card-img{
                display: flex;
                justify-content: flex-start;
                flex-flow: row wrap;
            }
            .list-card-img img{
                margin: 5px 5px;
            }
            ::v-deep .list-card-img .el-upload-list__item{
                display: none !important;
            }
            ::v-deep .list-card-img .el-upload-list__item-name{
                display: none !important;
            }

        }

    }
}

::v-deep .register-from .el-input .el-input__inner{
    height: 45px !important;
}

::v-deep .register-from .leftNone .el-input__inner{
    border-left: none !important;
}

::v-deep .register-from .el-form-item.is-error .el-input__inner{
    border-left: 1px solid #F56C6C !important;
}


@media screen and (max-width: 540px) {
   
    .register-header{
        width: 100%;
        background: #fff;
        box-shadow: 0 3px 8px 0 hsla(0,0%,42%,.1);
        box-sizing: border-box;
        padding: 18px 0;
        .logo-header-box{
            width: 100%;
            border: 1px solid;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
    .step-1{
        width: 99%;height: 20px;
        margin: 60px auto 43px;
    }
    .register-header .logo-header-box{
        width: 100%;
    }
    .register-from{
        width: 99%;
    }
    .register-from .el-cascader{
        width: 90%;
    }
    .register-from .el-input{
        width: 90%;
    }
    
    .register-from .widthCodeInput{
        width: 52%;
    }
    .regisButton{
        width: 90%;height: 46px;
        margin-left: 4%;
    }
    .checkde{
        margin-left: 4%;
    }
    .textSky{
        margin-right: 20px;
    }

}
</style>